import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { createSurveyByType } from 'actions'
import { connectApi } from 'libs/connectApi'
import { toast } from 'libs/toast'
import ChooseSurveyTypeModalV2 from 'components/Admin/Surveys/ChooseSurveyTypeModalV2'
import { useNavbarMenuContext } from 'organisms/NavBar/context'

const ChooseSurveyTypeModalContainer = ({
  createSurveyByType,
  handleClose,
  history,
  isOpenModal,
  updateSurvey,
  workspaceToken,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { updateContextData } = useNavbarMenuContext()

  const handleCreateSurvey = async (template) => {
    setIsLoading(true)
    try {
      const surveyData = await createSurveyByType('generic_embed')
      if (!surveyData) {
        toast.error('Something went wrong while creating the survey. Please try again.')
        return
      }
      await updateSurvey.callApi({
        url: `account/survey/${surveyData.id}/`,
        data: { type: 'n/a' },
      })
      updateContextData()
      handleClose()
      history.push(`/${workspaceToken}/settings/surveys/${surveyData.id}/settings/`, { template })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ChooseSurveyTypeModalV2
      handleClose={handleClose}
      isOpenModal={isOpenModal}
      handleOnSelectNPS={() => handleCreateSurvey('NPS')}
      handleOnSelectCES={() => handleCreateSurvey('CES')}
      handleOnSelectCSAT={() => handleCreateSurvey('CSAT')}
      handleOnSelectFiveStar={() => handleCreateSurvey('5-STAR')}
      isLoading={isLoading}
    />
  )
}

ChooseSurveyTypeModalContainer.propTypes = {
  createSurveyByType: PropTypes.func,
  handleClose: PropTypes.func,
  history: PropTypes.object,
  isOpenModal: PropTypes.bool,
  updateSurvey: PropTypes.object,
  workspaceToken: PropTypes.string,
}

const mapDispatch = (dispatch) => ({
  createSurveyByType: (surveyType) => dispatch(createSurveyByType(surveyType)),
})

export default compose(
  withRouter,
  connect(null, mapDispatch),
  connectApi({
    name: 'updateSurvey',
    method: 'patch',
    skip: true,
  })
)(ChooseSurveyTypeModalContainer)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Admin/Surveys/ChooseSurveyTypeModal/index.js